import React from 'react';
import Config from 'Config';

class ErrorWrapper extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error, info) {
        console.error("Failed to render", error);
        console.error("componentStack:", info.componentStack);
        this.setState({
            hasError: true
        });
    }

    render() {
        if (this.state.hasError) {
            return <p>Trouble rendering this component. See log.</p>;
        }

        return this.props.children;
    }
}

const catchErrors = (Component) => {
    // Return component if error wrapper disabled
    return Config.ENABLE_ERROR_WRAPPER === true ? (props) => (
        <ErrorWrapper>
            <Component {...props}/>
        </ErrorWrapper>
    ) : Component;
};

export default catchErrors;



// WEBPACK FOOTER //
// ./public/hoc/catchErrors.jsx